{
  "name": "sharelock",
  "version": "0.0.0",
  "packageManager": "npm@10.9.2",
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "scripts": {
    "ng": "ng",
    "mock:server": "node --watch server/server.js",
    "start:local": "ng serve --configuration=local-dev",
    "start:dev": "ng serve --configuration=dev",
    "start-clean:dev": "npx ng cache clean && ng serve --configuration=dev",
    "start:uat": "ng serve --configuration=uat",
    "start:prod": "ng serve --configuration=prod",
    "start:mock": "node --watch server/server.js & ng serve --configuration=mock",
    "install:ci": "npm i & npm install -D tailwindcss",
    "build:dev": "ng build --configuration=dev",
    "build:uat": "ng build --configuration=uat",
    "build:prod": "ng build --configuration=prod",
    "watch": "ng build --watch --configuration=local-dev",
    "test": "ng test --watch=false",
    "test:ci": "ng test --watch=false",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
    "prepare": "husky",
    "updates:check": "npx npm-check-updates",
    "updates:interactive": "npx npm-check-updates -i"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/material-moment-adapter": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-server": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@angular/ssr": "^22.2.1",
    "@cospired/i18n-iso-languages": "^4.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@tailwindcss/postcss": "^4.2.1",
    "express": "^5.2.1",
    "file-saver": "^2.0.5",
    "i18n-iso-countries": "^7.14.0",
    "json-server": "^0.17.4",
    "jszip": "^3.10.1",
    "ngx-mask": "^22.2.1",
    "ngx-quill": "^31.0.1",
    "ngx-translate-multi-http-loader": "^20.0.0",
    "npm-check-updates": "^19.6.3",
    "quill": "2.0.2",
    "rxjs": "~7.8.2",
    "swiper": "^12.1.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@eslint/js": "^9.39.3",
    "@types/express": "^5.0.6",
    "@types/file-saver": "^2.0.7",
    "@types/node": "^25.3.3",
    "angular-eslint": "^22.5.0",
    "autoprefixer": "^10.4.27",
    "eslint": "^9.25.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "husky": "^9.1.7",
    "jsdom": "^30.1.1",
    "lint-staged": "^16.3.1",
    "postcss": "^8.5.8",
    "prettier": "^3.8.1",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "tailwindcss": "^4.2.1",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.58.2",
    "vitest": "^5.0.0"
  },
  "overrides": {
    "@angular/compiler-cli": {
      "@babel/core": "7.29.7"
    },
    "express@^5.2.1": {
      "body-parser": "2.3.0"
    },
    "immutable": "5.1.8",
    "vite": {
      "esbuild": "0.28.1"
    }
  }
}
